import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {types} from 'main/tools';
import {DomainStore} from 'shared/store';
import {successAlert} from 'shared/tools';

class TeamContainerState {
  scope;
  match;
  store = new DomainStore();

  cycle;
  selectedReviewee = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match, cycle, scope}) {
    this.match = match;
    this.scope = scope;
    this.cycle = cycle;
  }

  async shareReview() {
    const review = this.selectedReviewee.currentEmployeeManagerReview;

    const {model} = await this.store.post(
      review.link('share'),
      types.PERFORMANCE_REVIEWS.REVIEW
    );

    if (model) {
      this.interactiveAgent.refresh();
      this.closeShareWithRevieweeModal();
      successAlert(t('performance_reviews.view.alerts.Review shared.'));
    }
  }

  async unshareReview() {
    const review = this.selectedReviewee.currentEmployeeManagerReview;

    const {model} = await this.store.post(
      review.link('unshare'),
      types.PERFORMANCE_REVIEWS.REVIEW
    );

    if (model) {
      this.interactiveAgent.refresh();
      this.closeUnshareRevieweeModal();
      successAlert(t('performance_reviews.view.alerts.Review unshared.'));
    }
  }

  setInteractiveAgent(interactiveAgent) {
    this.interactiveAgent = interactiveAgent;
  }

  canShareReviewee(reviewee) {
    if (!reviewee) {
      return false;
    }

    return reviewee.hasLink('share');
  }

  canUnshareReviewee(reviewee) {
    if (!reviewee) {
      return false;
    }

    return reviewee.hasLink('unshare');
  }

  writePathForReviewee(reviewee) {
    return `/reviews/reviewees/${reviewee.id}/employee/${reviewee.employee.id}/${reviewee.employee.urlSlug}/write`;
  }

  goToWriteReview(reviewee) {
    window.location = this.writePathForReviewee(reviewee);
  }

  customLinksFor(reviewee) {
    const links = [];

    if (reviewee.currentEmployeeManagerReview?.hasLink('unshare')) {
      links.push(
        {
          text: 'performance_reviews.view.Unshare',
          action: reviewee => this.openUnshareRevieweeModal(reviewee)
        }
      );
    }

    return links;
  }
}

export default TeamContainerState;
